import React from 'react';
import styled from 'styled-components';

import { formatPriceByLocale } from 'utils/utils';

export default function OrderInvoicePriceDetail({subTotal, shippingPrice}) {
  return (
    <PriceDetailSection>
      <PriceBlock>
        <PriceLabel>{'상품 금액'}</PriceLabel>
        <Price>{`${formatPriceByLocale('ko', subTotal)}원`}</Price>
      </PriceBlock>
      <PriceBlock>
        <PriceLabel>{'배송비'}</PriceLabel>
        <Price>{`${formatPriceByLocale('ko', shippingPrice)}원`}</Price>
      </PriceBlock>
    </PriceDetailSection>
  )
}

const PriceDetailSection = styled.div`
  padding-top: calc(100vw * (23 / 375));
  padding-bottom: calc(100vw * (23 / 375));
`;

const PriceBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items:  center;
  margin-bottom: calc(100vw * (25 / 375));

  &:last-child {
    margin-bottom: 0;
  }
`;

const PriceLabel = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16.8 / 375));
  color: #4E4E4E; 
`;

const Price = styled.span`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (19.2 / 375));
  color: #121212; 
`